import { ReactNode } from 'react'
import { cn } from '@/utils/styles/cn'

interface SectionProps {
    children: ReactNode
    /** Anchor id, e.g. for scroll targets */
    id?: string
    /** Extends the inner container, which is constrained to the page width */
    className?: string
    /** Extends the outer full-width layer, e.g. for full-bleed backgrounds */
    bleedClassName?: string
}

/**
 * Standard page section: full-width outer layer with an inner container
 * aligned to the page grid (max-w-page plus the standard gutters).
 */
export function Section({ children, id, className, bleedClassName }: SectionProps) {
    return (
        <section id={id} className={cn('w-full flex justify-center', bleedClassName)}>
            <div className={cn('w-full max-w-page px-4 md:px-8', className)}>{children}</div>
        </section>
    )
}
